import {
  Component,
  OnInit,
  computed,
  inject,
  input,
  model,
  output,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { NgIconComponent } from '@ng-icons/core';

import { InjectAttributeDirective } from '@directives/inject-attribute.directive';

import { AnalyticsLabelValuePipe } from '@cxc/ui-kit/pipes';

@Component({
  selector: 'export-report-modal',
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    InputTextModule,
    FormsModule,
    NgIconComponent,
    ProgressSpinnerModule,
    InjectAttributeDirective,
    AnalyticsLabelValuePipe,
  ],
  templateUrl: './export-report-modal.component.html',
})
export class ExportReportModal implements OnInit {
  private sanitizer = inject(DomSanitizer);

  visible = model<boolean>(false);
  selectedCount = input<number>(0);
  previewItems = input<string[]>([]);
  loading = input<boolean>(false);
  fileNameData = input<
    | {
        originator?: string;
        lender?: string;
        activeTab: string;
        date: string;
      }
    | undefined
  >(undefined);

  back = output<void>();
  download = output<{ format: 'pdf' | 'png'; fileName: string }>();

  format = signal<'pdf' | 'png'>('pdf');
  fileName = model('');

  ngOnInit() {
    if (this.fileNameData()) {
      const firstPartOfName =
        this.fileNameData()!.lender ||
        this.fileNameData()!.originator ||
        'Report';
      // Em dash, not a plain hyphen (LEN-1029 smoke test finding): the HU's
      // own filename example is "[Facility/Originator] — Cash Flow —
      // [Cut-off date]" -- this builder is shared by every section that
      // opens this modal (Insights, Concentrations, Cash Flow), so the fix
      // applies to all of them, not just the one HU that caught it.
      const name = `${firstPartOfName} — ${this.fileNameData()!.activeTab} — ${this.fileNameData()!.date}`;
      this.fileName.set(name);
    }
  }

  safePreviewItems = computed<SafeHtml[]>(() =>
    this.previewItems().map(html =>
      this.sanitizer.bypassSecurityTrustHtml(html)
    )
  );
}
